<template>
    <router-link
    to="/"
    class="logo bxs-logo"
    :style="{ maxWidth: maxWidth }">
        <img :src="src">
    </router-link>
</template>

<script>
export default {
    name: 'logo',
    props: {
        'max-width': {
            type: String,
            required: false,
            default: '44px'
        },
        src: {
            type: String,
            required: false,
            default: '/img/logo.png'
        }
    }
}
</script>

<style lang="scss" scoped>
a {
    display: inline-block;
    position: relative;
    text-decoration: none;
    vertical-align: middle;

    > img {
        display: block;
        position: relative;
        width: 100%;
        max-width: 100%;
        height: auto;
    }
}
</style>